import { ENV_QUERY_KEY, useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { SETTINGS_QUERY_KEY } from '@sparklayer-io/spark-dash-core/context/settings-context';
import { useHandlers, useSite } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PlatformConnectRequest, PlatformConnectResponse } from '../types';
import { usePlatformApi } from './use-platform-api';

export function useConnectPlatform() {
  const { navigationHandler } = useHandlers();
  const { platformApi } = usePlatformApi();
  const site = useSite();
  const env = useEnv();
  const queryClient = useQueryClient();

  return useMutation<PlatformConnectResponse, unknown, PlatformConnectRequest>({
    mutationFn: (payload) => platformApi.connect(env.team.slugged_name, env.environment, payload),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({
        queryKey: [ENV_QUERY_KEY, site.siteId, site.siteEnv],
      });
      void queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });

      if (data.redirect_to) {
        navigationHandler.navigate(data.redirect_to, { absolute: true, top: true });
      }
    },
  });
}
